module.exports = __webpack_public_path__ + "static/media/vip-round.972634a1.png";